import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';

const faqsData = [
  {
    id: 1,
    question: 'What types of insurance do you offer?',
    answer:
      'We offer a wide range of insurance options, including life, health, auto, and property insurance, each tailored to fit your unique needs.',
  },
  {
    id: 2,
    question: 'How do I get a quote?',
    answer:
      'You can request a free quote online through our website by filling out our simple quote form or by contacting one of our insurance advisors directly.',
  },
  {
    id: 3,
    question: 'How do I file a claim?',
    answer:
      'Filing a claim is simple and fast. You can submit your claim through our online portal, mobile app, or by calling our 24/7 dedicated claims hotline.',
  },
  {
    id: 4,
    question: 'What factors affect my insurance premiums?',
    answer:
      'Premiums are determined by factors such as coverage type, policy limits, deductibles, personal history, and qualifying safety discounts.',
  },
  {
    id: 5,
    question: 'Can I customize my insurance coverage?',
    answer:
      'Yes! All of our insurance policies are fully customizable with flexible add-ons and riders to ensure you get coverage tailored to your lifestyle.',
  },
];

const FaqSection = () => {
  const [openId, setOpenId] = useState(1); // Default first item open as in screenshot

  const toggleFaq = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="faq-section-container" id="faq">
      <div className="faq-content-wrapper">
        
        {/* Header */}
        <div className="faq-header-box">
          <h2 className="faq-main-title">Frequently asked questions</h2>
          <p className="faq-main-subtitle">
            Want to know more or have a question? You can always reach us at{' '}
            <a href="mailto:meenalic50@gmail.com" className="faq-email-link">
              meenalic50@gmail.com
            </a>{' '}
            but here are some of our most frequent questions.
          </p>
        </div>

        {/* Accordion List */}
        <div className="faq-accordion-list">
          {faqsData.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`faq-accordion-item ${isOpen ? 'item-open' : ''}`}
                onClick={() => toggleFaq(item.id)}
              >
                <div className="faq-item-question-row">
                  <h3 className="faq-item-question">{item.question}</h3>
                  <button
                    type="button"
                    className="faq-toggle-icon-btn"
                    aria-expanded={isOpen}
                    aria-label="Toggle FAQ answer"
                  >
                    {isOpen ? <X size={18} /> : <Plus size={18} />}
                  </button>
                </div>

                {isOpen && (
                  <div className="faq-item-answer-box">
                    <p className="faq-item-answer">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
